import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Route } from '@angular/router';
import { Alert, AlertService, AlertType } from '@michelin/theme';
import { UserProfileDto, UserProfileNoIdDto } from 'src/app/shared/models/user/user-profile-dto';
import { UserProfileService } from 'src/app/shared/services/user-profile/user-profile.service';

@Component({
    selector: 'app-update-user-profile',
    templateUrl: './update-user-profile.component.html',
    standalone: false
})
export class UpdateUserProfileComponent implements OnInit {
  loading = false;
  id: number = null;
  form: FormGroup = null;
  currentProfile: UserProfileDto = null;
  values: UserProfileNoIdDto = null;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly alertService: AlertService,
    private readonly userProfileService: UserProfileService
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.id = this.route.snapshot.params['id'];
    this.userProfileService
      .findById(this.id)
      .subscribe((value) => (this.currentProfile = value))
      .add(() => (this.loading = false));
  }

  onFormChange(event: any) {
    this.form = event.form;
    this.values = event.values;
  }

  submitForm() {
    if (this.form.invalid) {
      return this.alertService.showAlert({ type: AlertType.critical, content: 'Preencha todos os campos obrigatórios!' } as Alert);
    }

    this.loading = true;
    this.userProfileService
      .update(this.id, this.values)
      .subscribe({
        next: () => {
          this.alertService.showAlert({ type: AlertType.success, content: 'Grupo de Usuário atualizado com sucesso!' } as Alert);
        },
        error: () => {
          this.alertService.showAlert({ type: AlertType.critical, content: 'Ocorreu um erro ao atualizar o Grupo de Usuário!' } as Alert);
        }
      })
      .add(() => (this.loading = false));
  }
}
